import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function BodyReliefProblemSection() {
  return <section className="py-8 sm:py-10 bg-white" data-id="element-243">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} data-id="element-245">
          {/* As Seen On - Mobile Only */}
          <div className="mb-4 sm:hidden" data-id="element-246">
            <p className="text-xs text-charcoal-light text-center mb-2 font-light tracking-wide" data-id="element-247">
              AS SEEN ON
            </p>
            <img src="https://cdn.magicpatterns.com/uploads/hSpRuFC5repS5nRdGHPPBc/ss_seen_on.png" alt="As seen on wellness publications" className="w-full h-auto" loading="lazy" data-id="element-248" />
          </div>

          <div className="flex justify-center mb-3 sm:mb-4" data-id="element-249">
            <AlertCircle className="w-6 h-6 sm:w-8 sm:h-8 text-charcoal-light opacity-50" data-id="element-250" />
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-charcoal mb-4 sm:mb-6 tracking-tight" data-id="element-251">
            Why Most Pain Creams Fail the Moment You Need Them Most
          </h2>

          <div className="space-y-3 sm:space-y-4 text-sm sm:text-base text-charcoal-light leading-relaxed font-light" data-id="element-252">
            <p data-id="element-253">
              Cold creams don't relax tension. They shock the skin, overload the
              nerves, and silence sensation temporarily.
            </p>
            <p className="font-normal text-charcoal" data-id="element-254">
              So it feels better for a moment… Then stiffness returns. Pressure
              builds again. By evening, everything feels tight.
            </p>
            <div className="pt-2" data-id="element-255">
              <span className="inline-block px-4 py-2 bg-gray-100 rounded-lg text-charcoal text-xs sm:text-sm font-normal border-l-4 border-charcoal" data-id="element-256">
                Because most everyday pain isn't damage. It's sustained
                contraction.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}